/** The texts of impact sessions (ANN-36), spread into the app's dictionaries (`lib/i18n.tsx`). */
export const impactEn = {
  impactStart: 'Make an impact',
  impactContinue: 'Continue your impact session',
  impactHint: 'Give studies their first or second completed review: one study after another from this view, until none is left.',
  impactSession: 'Impact session',
  impactNone: 'No eligible studies in this view right now.',
  // After the number, which narrow screens show alone.
  impactProgress: 'studies checked this session',
  impactProgress_one: 'study checked this session',
  impactMilestone: 'studies checked. Thank you for contributing.',
  impactCheckNext: 'Check & next',
  impactSkip: 'Skip',
  impactEnd: 'You’ve reached the end of this pass.',
  impactEndDetail: '{checked} checked · {skipped} skipped',
  impactEndHint: 'Skipped studies come again in a new pass; studies you checked do not.',
  impactAgain: 'Check again',
  impactBackImages: 'Back to images',
  impactBackCollection: 'Back to collection',
  impactIntro: 'One click opens a study that still needs a first or second check, then the next, until none is left. Start from the images page or a collection to keep its filters.',
}

export const impactDe: Record<keyof typeof impactEn, string> = {
  impactStart: 'Beitrag leisten',
  impactContinue: 'Impact-Sitzung fortsetzen',
  impactHint: 'Studien ihre erste oder zweite abgeschlossene Prüfung geben: eine Studie nach der anderen aus dieser Ansicht, bis keine mehr übrig ist.',
  impactSession: 'Impact-Sitzung',
  impactNone: 'In dieser Ansicht gibt es gerade keine passenden Studien.',
  impactProgress: 'Studien in dieser Sitzung geprüft',
  impactProgress_one: 'Studie in dieser Sitzung geprüft',
  impactMilestone: 'Studien geprüft. Danke für Ihren Beitrag.',
  impactCheckNext: 'Prüfen & weiter',
  impactSkip: 'Überspringen',
  impactEnd: 'Sie haben das Ende dieses Durchgangs erreicht.',
  impactEndDetail: '{checked} geprüft · {skipped} übersprungen',
  impactEndHint: 'Übersprungene Studien kommen in einem neuen Durchgang wieder, geprüfte nicht.',
  impactAgain: 'Erneut prüfen',
  impactBackImages: 'Zurück zu den Bildern',
  impactBackCollection: 'Zurück zur Sammlung',
  impactIntro: 'Ein Klick öffnet eine Studie, die noch eine erste oder zweite Prüfung braucht, dann die nächste, bis keine mehr übrig ist. Starten Sie auf der Bilderseite oder in einer Sammlung, um deren Filter zu behalten.',
}
